import React, { useState, useEffect } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import FilterModal from "./FilterModel";
import EmployeeModal from "./EmployeeModal";
import DrugModal from "./DrugModal";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaStore, FaTrash, FaEye, FaUser, FaPills, FaTimes, FaClock, FaPlus, FaFilter, FaSearch, FaChevronLeft, FaChevronRight, FaUserTie, FaHome, FaUsers, FaMapMarkerAlt, FaPhone, FaEnvelope, FaCalendarAlt, FaDownload, FaTimesCircle } from "react-icons/fa";
import axios from "axios";
import "./Print.css";
import ExcelJS from "exceljs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";
import Swal from "sweetalert2";

const OutletPage = () => {
  const [isPrinting, setIsPrinting] = useState(false);
  const navigate = useNavigate();
  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [isDetailVisible, setIsDetailVisible] = useState(false);
  const [filterOption, setFilterOption] = useState("default");
  const [pageSize, setPageSize] = useState(10);
  const [statusFilter, setStatusFilter] = useState("all");
  const [userRole, setUserRole] = useState(null);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [isShiftVisible, setIsShiftVisible] = useState(false);
  const [shiftData, setShiftData] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [employees, setEmployees] = useState([]);
  const [drugs, setDrugs] = useState([]);
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [isDrugModalOpen, setIsDrugModalOpen] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedDrugs, setSelectedDrugs] = useState([]);

  const handleOpenEmployeeModal = (employees) => {
    setSelectedEmployees(employees);
    setIsEmployeeModalOpen(true);
  };

  const handleOpenDrugModal = (drugs) => {
    setSelectedDrugs(drugs);
    setIsDrugModalOpen(true);
  };
  const fetchEmployees = async () => {
    if (!selectedOutlet) return;
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee?outlet_id=${selectedOutlet.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      const data = await response.json();
      console.log("Employee API Response:", data); // Debugging response
  
      if (data.success) {
        console.log("Setting Employee State:", data.data); // Cek apakah data masuk ke state
  
        // Filter manual jika API tidak mendukung outlet_id
        const filteredEmployees = data.data.filter(emp => emp.outlet.id === selectedOutlet.id);
        setEmployees(filteredEmployees || []);
      } else {
        console.error("Failed to fetch employee:", data.message);
        setEmployees([]);
      }
    } catch (error) {
      console.error("Error fetching employee:", error);
      setEmployees([]);
    }
  };
  
const fetchDrugs = async () => {
  if (!selectedOutlet) return;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/v1/drug?id_outlet=${selectedOutlet.id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );
    const data = await response.json();
    console.log("Drugs API Response:", data); // Debugging response

    if (data.success) {
      console.log("Setting Drugs State:", data.data); // Cek apakah data masuk ke state
      setDrugs(data.data || []);
    } else {
      console.error("Failed to fetch drugs:", data.message);
      setDrugs([]);
    }
  } catch (error) {
    console.error("Error fetching drugs:", error);
    setDrugs([]);
  }
};


  useEffect((selectedOutlet) => {
    if (isDrugModalOpen) {
      fetchDrugs();
    }
  }, [selectedOutlet,isDrugModalOpen]);
  
  useEffect((selectedOutlet) => {
    if (isEmployeeModalOpen) {
      fetchEmployees();
    }
  }, [selectedOutlet,isEmployeeModalOpen]);
  const exportToPDF = async () => {
    const outletName = selectedOutlet?.name || "Tidak Diketahui";

    const monthNames = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    const selectedPeriodData = periods?.find(p => String(p.id) === String(selectedPeriod));

    let periodeBulan = "Tidak Diketahui";
    let totalDays = 30; // Default 30 hari
    if (selectedPeriodData) {
        const monthNumber = parseInt(selectedPeriodData.month, 10);
        const monthName = monthNames[monthNumber - 1] || "Tidak Diketahui";
        periodeBulan = `${monthName} ${selectedPeriodData.year}`;

        totalDays = new Date(selectedPeriodData.year, monthNumber, 0).getDate();
    }

    let tableHTML = `
        <div style="text-align: center;">
            <h2>Shift Bulan ${periodeBulan} Apotek Djaya Medica</h2>
            <h3>Outlet: ${outletName}</h3><br>
            <table style="width: 100%; border-collapse: collapse; text-align: center; font-size: 12px; border: 1px solid black;">
                <thead style="background-color: #4CAF50; color: white;">
                    <tr>
                        <th rowspan="2" style="padding: 8px; border: 1px solid black;">No</th>
                        <th rowspan="2" style="padding: 8px; border: 1px solid black;">Nama</th>`;

    for (let i = 1; i <= totalDays; i++) {
        tableHTML += `<th style="padding: 4px; border: 1px solid black;">${i}</th>`;
    }

    tableHTML += `</tr><tr>`;

    for (let i = 1; i <= totalDays; i++) {
        let date = new Date(selectedPeriodData.year, parseInt(selectedPeriodData.month) - 1, i);
        let dayName = date.toLocaleDateString("id-ID", { weekday: "short" });
        tableHTML += `<th style="padding: 4px; border: 1px solid black; background-color:rgb(251, 255, 0); color: black;">${dayName}</th>`;
    }

    tableHTML += `</tr></thead><tbody>`;

    let nomorUrut = 1;
    if (!shiftData || shiftData.length === 0) {
        tableHTML += `
            <tr>
                <td colspan="${totalDays + 2}" style="padding: 8px; border: 1px solid black; text-align: center;">Tidak ada data shift</td>
            </tr>`;
    } else {
        shiftData.forEach((employee) => {
            tableHTML += `<tr>
                <td style="padding: 8px; border: 1px solid black;">${nomorUrut}</td>
                <td style="padding: 8px; border: 1px solid black;">${employee.full_name}</td>`;

            console.log(`Cek shift untuk: ${employee.full_name}`, employee.shifts);

            for (let i = 1; i <= totalDays; i++) {
                let formattedDate = `${selectedPeriodData.year}-${String(selectedPeriodData.month).padStart(2, "0")}-${String(i).padStart(2, "0")}`;

                let shift = employee.shifts.find(s => s.day === formattedDate);
                let shiftText = shift ? shift.shift.code : "-";

                let bgColor = shift ? "#D3ECA7" : "#FFFFFF";

                tableHTML += `<td style="padding: 4px; border: 1px solid black; background-color: ${bgColor};">${shiftText}</td>`;
            }

            tableHTML += `</tr>`;
            nomorUrut++;
        });
    }

    tableHTML += `</tbody></table></div>`;

    const element = document.createElement("div");
    element.innerHTML = tableHTML;
    document.body.appendChild(element);

    html2pdf()
        .set({
            margin: 10,
            filename: `Shift_Karyawan_${outletName}_${periodeBulan}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 1.75, useCORS: true },
            jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
        })
        .from(element)
        .save()
        .then(() => {
            document.body.removeChild(element);
        });
};

  useEffect(() => {
    const role = localStorage.getItem("role"); // Atau cara lain mengambil role
    setUserRole(role);
  
    if (role !== "owner") {
      setShowAccessDenied(true);
    }
  }, []);
  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    setIsFilterOpen(false);
    fetchData(appliedFilters); // Fetch data sesuai filter
  };
  
  const fetchData = async (appliedFilters = {}) => {
    setIsLoading(true);
  
    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!token) {
        console.error("Token tidak ditemukan. Silakan login ulang.");
        return;
      }
  
      const params = new URLSearchParams({
        per_page: appliedFilters.per_page || 10,
        page: appliedFilters.page || 1,
        order_by: appliedFilters.order_by || "created_at",
        status: appliedFilters.status || "all",
      }).toString();
  
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet?${params}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.data.success) {
        setOutlets(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPeriods = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await response.json();
      setPeriods(data.data); // Simpan daftar periode shift
      setSelectedPeriod(data.data[0]?.id || ""); // Pilih periode pertama jika ada
    } catch (error) {
      console.error("Error fetching periods:", error);
    }
  };
  const fetchShifts = async () => {
    if (!selectedOutlet || !selectedPeriod) return;
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee/shift?outlet_id=${selectedOutlet.id}&period_id=${selectedPeriod}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      const data = await response.json();
      console.log("API Response:", data); // Log Response dari API
  
      if (data.success) {
        console.log("Shifts Fetched:", data.data); // Log Data Shift yang Diterima
        setShiftData(data.data || []);
      } else {
        console.error("Failed to fetch shifts:", data.message);
      }
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };
  
  const showShiftDetail = async () => {
    setIsShiftVisible(true);
    await fetchPeriods(); // Ambil daftar periode shift saat modal dibuka
  };
  const closeShiftDetail = () => {
    setIsShiftVisible(false);
    setShiftData([]); // Reset data shift
  };
  
  const getDaysInMonth = (selectedPeriod, periods = []) => {
    if (!selectedPeriod || !periods.length) return 31; // Default jika belum ada periode
    const period = periods.find((p) => p.id === selectedPeriod);
    if (!period) return 31;
    return new Date(period.year, period.month, 0).getDate(); // Hitung jumlah hari dalam bulan
  };
  
  const getYear = (selectedPeriod, periods = []) => {
    if (!selectedPeriod || !periods.length) return new Date().getFullYear();
    const period = periods.find((p) => p.id === selectedPeriod);
    return period ? period.year : new Date().getFullYear();
  };
  
  const getMonth = (selectedPeriod, periods = []) => {
    if (!selectedPeriod || !periods.length) return new Date().getMonth() + 1;
    const period = periods.find((p) => p.id === selectedPeriod);
    return period ? period.month : new Date().getMonth() + 1;
  };
  
  const getDayName = (date) => {
    const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    return days[date.getDay()];
  };
  
  // Trigger fetch pertama kali tanpa filter
  useEffect(() => {
    fetchData();
  }, []);
  const columns = React.useMemo(
    () => [
      // { Header: "ID", accessor: "id" },
      {
      Header: "No",
      Cell: ({ row }) => row.index + 1 
    },
      { Header: "Nama Outlet", accessor: "name" },
      { Header: "Kota", accessor: "kota" },
      { Header: "Telepon", accessor: "phone" },
      { Header: "Email", accessor: "email" },
      { Header: "Status", accessor: "status" },
      {
       Header: "Aksi",
Cell: ({ row }) => (
  <div className="flex space-x-3">

    {/* DETAIL */}
    <button
      className="p-2 bg-green-100 hover:bg-green-200 rounded-lg shadow-md text-green-600 hover:text-green-700 transition transform hover:scale-110"
      title="Detail"
      onClick={() => handleDetail(row.original)}
    >
      <FaEye/>
    </button>

    {/* EDIT */}
    <button
      className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg shadow-md text-blue-600 hover:text-blue-700 transition transform hover:scale-110"
      title="Edit"
      onClick={() => handleEdit(row.original)}
    >
      <FaEdit />
    </button>

    {/* DELETE */}
    <button
      className="p-2 bg-red-100 hover:bg-red-200 rounded-lg shadow-md text-red-600 hover:text-red-700 transition transform hover:scale-110"
      title="Hapus"
      onClick={() => handleDelete(row.original)}
    >
      <FaTrash />
    </button>


  </div>
),
      },
    ],
    []
  );

  const handleEdit = (outlet) => {
    navigate(`/enterprise/outlet/edit-outlet/${outlet.id}`);
  };

const handleDelete = async (row) => {
  // Ganti window.confirm dengan SweetAlert2
  const result = await Swal.fire({
    title: `Yakin ingin menghapus outlet: ${row.name}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  });

  if (!result.isConfirmed) return;

  try {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/v1/outlet/${row.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Gagal menghapus outlet");
    }

    // Ganti alert biasa dengan SweetAlert2 sukses
    await Swal.fire({
      title: "Terhapus!",
      text: `Outlet "${row.name}" telah dihapus.`,
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });

    fetchData(); // Refresh data setelah delete
  } catch (error) {
    console.error("Error saat menghapus outlet:", error);

    await Swal.fire({
      title: "Gagal!",
      text: `Gagal menghapus outlet: ${error.message}`,
      icon: "error",
    });
  }
};

  const handleDetail = (outlet) => {
    console.log("Selected Outlet:", outlet); // Debugging
    setSelectedOutlet(outlet);
    setIsDetailVisible(true);
  };
  

  const closeDetail = () => {
    setIsDetailVisible(false);
    setSelectedOutlet(null);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex, globalFilter },
  } = useTable(
    { columns, data: outlets, initialState: { pageSize } },
    useGlobalFilter,
    usePagination
  );

return (
  <div className="min-h-screen flex flex-col space-y-6">

    {/* HEADER + BREADCRUMB */}
    <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-100">
      <div className="flex items-center gap-3">
        <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
          <FaStore className="text-green-600 text-xl" />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-800">Outlet</h1>
          <p className="text-gray-500 text-sm">Menampilkan semua data Outlet</p>
        </div>
      </div>

      {/* Breadcrumb */}
      <nav aria-label="Breadcrumb" className="mt-3 text-gray-500 text-sm">
        <ol className="flex items-center space-x-2">
          <li>
            <button
              onClick={() => navigate("/")}
              className="hover:text-gray-700 transition"
            >
              Enterprise
            </button>
          </li>
          <li>/</li>
          <li className="text-gray-400">Outlet</li>
        </ol>
      </nav>
    </div>

    {/* PANEL TABLE */}
    <div className="bg-white p-6 rounded-3xl shadow-xl border border-gray-100">

      {/* TOP ACTION BAR */}
      <div className="flex flex-col md:flex-row items-center gap-4">

        {/* Search */}
        <div className="relative w-full md:flex-1">
          <input
            type="text"
            placeholder="Cari outlet..."
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-green-300 focus:outline-none"
          />
          <FaSearch className="absolute left-3 top-3.5 text-gray-400" />
        </div>

        {/* Filter */}
        <button
          onClick={() => setIsFilterOpen(true)}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-xl shadow hover:shadow-md hover:bg-gray-100 transition active:scale-95"
        >
          <FaFilter className="text-green-600" />
          <span>Filter</span>
        </button>

        {/* Create */}
        <button
          onClick={() => navigate("/enterprise/outlet/create-outlet")}
          className="flex items-center gap-2 px-4 py-2 bg-yellow-400 text-white rounded-xl shadow hover:bg-yellow-700 hover:shadow-md transition active:scale-95"
        >
          <FaPlus />
          <span>Create</span>
        </button>
      </div>

      {/* TABLE */}
      <div className="mt-6">
        {isLoading ? (
          <div className="flex justify-center items-center py-10">
            <div className="h-10 w-10 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm">
            <table
              {...getTableProps()}
              className="min-w-full bg-white rounded-2xl"
            >
              <thead className="bg-green-50">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        className="p-4 text-left text-sm font-semibold text-gray-700 border-b"
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody {...getTableBodyProps()} className="divide-y">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className="hover:bg-gray-50 transition"
                    >
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          className="p-4 text-sm text-gray-700"
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-6 gap-3">
        <p className="text-sm text-gray-500">
          Menampilkan {page.length} data dari total {rows.length}
        </p>

        <div className="flex items-center space-x-2">
          <button
            onClick={previousPage}
            disabled={!canPreviousPage}
            className="flex items-center px-3 py-1.5 text-sm bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed active:scale-95"
          >
            <FaChevronLeft className="mr-1" />
            Prev
          </button>

          <span className="text-sm text-gray-600">
            Halaman <strong>{pageIndex + 1}</strong> dari{" "}
            <strong>{pageOptions.length}</strong>
          </span>

          <button
            onClick={nextPage}
            disabled={!canNextPage}
            className="flex items-center px-3 py-1.5 text-sm bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed active:scale-95"
          >
            Next
            <FaChevronRight className="ml-1" />
          </button>
        </div>
      </div>
    </div>

    {/* SIDE DETAIL PANEL */}
    {isDetailVisible && (
      <div className="w-full md:w-1/3 bg-white p-6 rounded-3xl shadow-2xl fixed right-0 top-20 h-[80vh] overflow-auto border border-gray-200 transition-all">

        {/* Close */}
        <button
          onClick={closeDetail}
          className="absolute top-4 right-4 text-gray-400 hover:text-red-500 transition"
          title="Close"
        >
          <FaTimes size={22} />
        </button>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">
          {selectedOutlet.name}
        </h2>

        {/* Status */}
        <div className="flex justify-center my-3">
          <span className="bg-green-100 text-green-600 px-4 py-1 rounded-full text-sm font-medium shadow">
            Active
          </span>
        </div>

        {/* DETAIL INFO */}
        <div className="text-gray-700 space-y-3 text-sm md:text-base">
          <p>
            <FaMapMarkerAlt className="inline mr-2 text-blue-500" />
            <strong>Kota:</strong> {selectedOutlet.kota ?? "-"}
          </p>
          <p>
            <FaPhone className="inline mr-2 text-green-500" />
            <strong>No. HP:</strong> {selectedOutlet.phone ?? "-"}
          </p>
          <p>
            <FaEnvelope className="inline mr-2 text-purple-500" />
            <strong>Email:</strong> {selectedOutlet.email ?? "-"}
          </p>

          <p>
            <FaUserTie className="inline mr-2 text-orange-500" />
            <strong>Manager:</strong> {selectedOutlet.manager?.name ?? "-"}
          </p>

          <p>
            <FaHome className="inline mr-2 text-gray-500" />
            <strong>Alamat:</strong>{" "}
            {typeof selectedOutlet.address === "string"
              ? selectedOutlet.address
              : JSON.stringify(selectedOutlet.address)}
          </p>
        </div>

        {/* BUTTON LISTS */}
        <div className="mt-6 space-y-3">

          <button
            onClick={showShiftDetail}
            className="flex items-center w-full gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-xl shadow hover:bg-gray-200 hover:shadow-md transition active:scale-95"
          >
            <FaClock className="text-blue-500" />
            Lihat Shift
          </button>

          <button
            onClick={() => handleOpenEmployeeModal(outlets.employees)}
            className="flex items-center w-full gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-xl shadow hover:bg-gray-200 hover:shadow-md transition active:scale-95"
          >
            <FaUsers className="text-green-500" />
            Lihat Karyawan
          </button>

          <button
            onClick={() => handleOpenDrugModal(outlets.drugs)}
            className="flex items-center w-full gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-xl shadow hover:bg-gray-200 hover:shadow-md transition active:scale-95"
          >
            <FaPills className="text-purple-500" />
            Lihat Daftar Obat
          </button>
        </div>

        {/* EDIT FLOATING */}
        <button
          onClick={() => handleEdit(selectedOutlet)}
          className="absolute bottom-4 right-4 bg-yellow-400 hover:bg-yellow-500 text-white p-3 rounded-full shadow-lg transition active:scale-95"
        >
          <FaEdit size={20} />
        </button>
      </div>
    )}
      
      {showAccessDenied && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4 text-center">Akses Ditolak</h2>
            <p className="text-gray-600 mb-4 text-center">
              Anda tidak memiliki hak akses untuk memasuki halaman ini.
            </p>
            <button
              onClick={() => navigate("/dashboard")}
              className="w-full bg-red-500 text-white py-2 rounded-lg shadow-md hover:bg-red-600"
            >
              Kembali ke Dashboard
            </button>
          </div>
        </div>
      )}
      
      {isFilterOpen && (
        <FilterModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          onApply={handleApplyFilters}
        />
      )}
      {/* Modal Employee */}
      <EmployeeModal
        isOpen={isEmployeeModalOpen}
        onClose={() => setIsEmployeeModalOpen(false)}
        employees={employees}
      />
      
      <DrugModal
        isOpen={isDrugModalOpen}
        onClose={() => setIsDrugModalOpen(false)}
        drugs={drugs} // Pastikan ini dikirimkan
      />
      
      {isShiftVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 print-container">
          <div
            className="bg-white p-6 rounded-2xl shadow-2xl w-[90vw] max-w-[1200px] overflow-auto max-h-[90vh] relative">
            <h2 className="text-2xl font-bold text-center mb-6 text-blue-700 flex items-center justify-center gap-2">
              <FaCalendarAlt/> Shift Karyawan
            </h2>
            
            {/* Dropdown Pilih Periode */}
            <select
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              {periods.map((period) => (
                <option key={period.id} value={period.id}>
                  {period.year} - {period.month}
                </option>
              ))}
            </select>
            
            {/* Tombol Ambil Data Shift */}
            <button
              onClick={fetchShifts}
              className="w-full bg-blue-600 text-white py-3 rounded-lg mb-6 hover:bg-blue-700 font-semibold transition-all duration-200"
            >
              Ambil Data Shift
            </button>
            
            {/* Tabel Shift */}
            <div className="overflow-auto max-w-full rounded-xl border border-gray-200 shadow-inner">
              <table className="w-full border-collapse text-sm text-gray-800 min-w-max">
                <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="border p-3 text-center font-semibold">Nama</th>
                  {Array.from({length: getDaysInMonth(selectedPeriod, periods)}, (_, i) => {
                    const date = new Date(getYear(selectedPeriod, periods), getMonth(selectedPeriod, periods) - 1, i + 1);
                    return (
                      <th key={i} className="border p-2 text-center text-xs font-medium text-gray-600">
                        {getDayName(date)} <br/> {i + 1}
                      </th>
                    );
                  })}
                </tr>
                </thead>
                <tbody>
                {shiftData.length > 0 ? (
                  shiftData.map((employee) => (
                    <tr key={employee.id} className="hover:bg-gray-50">
                      <td className="border p-2 font-medium text-gray-700">{employee.full_name}</td>
                      {Array.from({length: getDaysInMonth(selectedPeriod)}, (_, i) => {
                        const shift = employee.shifts.find((s) => {
                          const shiftDay = new Date(s.day).getDate();
                          return shiftDay === i + 1;
                        });
                        return (
                          <td key={`${employee.id}-${i}`} className="border p-2 text-center">
                            {shift ? shift.shift?.code || "—" : "—"}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={getDaysInMonth(selectedPeriod) + 1}
                      className="border p-3 text-center text-gray-500"
                    >
                      Tidak ada data shift
                    </td>
                  </tr>
                )}
                </tbody>
              </table>
            </div>
            
            {/* Tombol Export PDF */}
            <button
              onClick={exportToPDF}
              className="w-full mt-6 bg-red-500 text-white py-3 rounded-lg hover:bg-red-600 font-semibold flex items-center justify-center gap-2 transition-all"
            >
              <FaDownload/> Export PDF
            </button>
            
            {/* Tombol Tutup */}
            <button
              onClick={closeShiftDetail}
              className="w-full mt-2 bg-gray-400 text-white py-3 rounded-lg hover:bg-gray-500 font-medium flex items-center justify-center gap-2"
            >
              <FaTimesCircle/> Tutup
            </button>
          </div>
        </div>
      )}
    
    
    </div>
  );
};

export default OutletPage;
